import { formConstants } from '../../../../utils/constants/form-constants';

const RAMembersPortalFormData = ({
    ssoraMembersPortalFields
}) => {
    function buildRAMembersPortalFormData() {
        const formData = {};
        const {
            raMembersPortalTitle, raMembersPortalCriteria, raMembersPortalInformation, raMembersPortalImage, raMembersPortalFAQTitle, raMembersPortalFAQs,
            raMembersPortalUrl, raMembersPortalSecutixUrl, raMembersPortalSecutixPointOfSaleId, raMembersPortalSecutixVirtualOperator,
        } = ssoraMembersPortalFields;
        formData[formConstants.raMembersPortalTitle] = raMembersPortalTitle;
        formData[formConstants.raMembersPortalCriteria] = raMembersPortalCriteria;
        formData[formConstants.raMembersPortalInformation] = raMembersPortalInformation;
        formData[formConstants.raMembersPortalImage] = raMembersPortalImage;
        formData[formConstants.raMembersPortalFAQTitle] = raMembersPortalFAQTitle;
        formData[formConstants.raMembersPortalFAQs] = raMembersPortalFAQs;
        formData[formConstants.raMembersPortalUrl] = raMembersPortalUrl;
        formData[formConstants.raMembersPortalSecutixUrl] = raMembersPortalSecutixUrl;
        formData[formConstants.raMembersPortalSecutixPointOfSaleId] = raMembersPortalSecutixPointOfSaleId;
        formData[formConstants.raMembersPortalSecutixVirtualOperator] = raMembersPortalSecutixVirtualOperator;

        return formData;
    }


    return buildRAMembersPortalFormData();
};

export default RAMembersPortalFormData;
